import { RootStore } from '@/store';
import { DO_AUTH, activateAuthToken, activateAuthTokenByB3 } from '@/utils/api';
import { isTelegramApp } from '@/utils/isTelegramApp';
import { storage } from '@/utils/storage';

export async function handleTokenAuthentication(store: RootStore) {
  const b3token = new URLSearchParams(window.location.search).get('token');
  if (b3token) await storage.setItem('token', b3token);

  let token = await storage.getItem('token');

  if (token) {
    const accountData = await store.accountStore.getAccountData();

    if (!accountData?._id) {
      await storage.removeItem('token');
      token = null;
    } else {
      await store.accountStore.setAuthorizationToken(token);
    }
  }

  if (
    !token &&
    (isTelegramApp() ||
      b3token ||
      (DO_AUTH && import.meta.env.MODE === 'development'))
  ) {
    if (b3token) {
      await activateAuthTokenByB3(store.accountStore);
    } else {
      await activateAuthToken(store.accountStore);
    }
    await store.accountStore.getAccountData();
  }
}
